// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"defs","attrs":{},"children":[{"tag":"mask","attrs":{"id":"props.overlapMaskId_stroke1","maskUnits":"userSpaceOnUse","maskContentUnits":"userSpaceOnUse","mask-type":"luminance","x":"0","y":"0","width":"24","height":"24"},"children":[{"tag":"rect","attrs":{"x":"0","y":"0","width":"24","height":"24","fill":"#fff"}},{"tag":"path","attrs":{"stroke":"#000","d":"M21 21L3 3","strokeLinecap":"square","strokeWidth":"props.strokeWidth","fill":"none"}}]}]},{"tag":"g","attrs":{"id":"jump-off"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M9.50977 4.00195L9.49977 4.00195M9.49977 4.00195L9.00074 4.00195L8.99974 4.00095L9.49977 4.00195ZM19.225 4.775L14.5 9.5M20 14.5V14.999L20.001 15L20 14.5ZM20 14.5V14.49M14 4L20 4V10M4 4L4 20H20L4 4ZM11.4984 12.5019L11.5011 12.4992L11.5039 12.5019L11.5011 12.5047L11.4984 12.5019Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth","mask":"props.overlapMaskUrl_stroke1"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M21 21L3 3","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const JumpOffIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'jump-off',
    ref,
    icon: element,
  },
));

JumpOffIcon.displayName = 'JumpOffIcon';

export default JumpOffIcon;
